<template>
    <div>
        <div v-if="loading" class="loader-container">
            <div class="loader"></div> <!-- Stilizovani loader -->
        </div>
        <div class="row">
            <div class="col-md-24">
                <card>
                    <template slot="header">
                        <h5 class="card-category"></h5>
                        <h3 class="card-title">Doplatne karte ({{ totalRecords }}) ({{ totalPrice }} EUR)</h3>
                    </template>
                    <div class="row">
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Početak</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Početak" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Kraj</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Kraj" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endStamp">
                                </el-date-picker>
                            </base-input>
                            <!-- </card> -->
                        </div>

                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Storniranje/Plaćanje od</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Od" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.startActionStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <h4 slot="header" class="card-title">Storniranje/Plaćanje do</h4>
                            <base-input>
                                <el-date-picker type="datetime" placeholder="Do" value-format="timestamp"
                                    format="dd.MM.yyyy. HH:mm:ss" v-model="filter.endActionStamp">
                                </el-date-picker>
                            </base-input>
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Tablice</h4>
                            <base-input type="text" v-model="filter.plates" placeholder="Tablice">
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Broj karte</h4>
                            <base-input type="text" v-model="filter.ticketNumber" placeholder="Broj karte">
                            </base-input>
                            <!-- </card> -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Zona</h4>
                            <base-input>
                                <el-select v-model="filter.clientId" class="select-primary" name="zone" clearable>
                                    <el-option v-for="zone in zones" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Kontrolor</h4>
                            <base-input>
                                <el-select v-model="filter.employeeId" class="select-primary" name="zone" clearable>
                                    <el-option v-for="zone in employees" class="select-primary"
                                        :style="zone.active ? 'color: green;' : 'color:red'"
                                        :label="zone.active ? zone.name + ' ' + zone.lastName + ' AKTIVAN' : zone.name + ' ' + zone.lastName + ' NEAKTIVAN'"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title">Status plaćanja</h4>
                            <base-input>
                                <el-select v-model="filter.paymentStatusId" class="select-primary" name="zone"
                                    clearable>
                                    <el-option v-for="zone in paymentStatuses" class="select-primary" :label="zone.name"
                                        :value="zone.id" :key="zone.id"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                        <div class="col-md-3">
                            <base-checkbox class="text-left" v-model="filter.filterOldTickets">
                                Prikazi stare kazne
                            </base-checkbox>
                            <base-checkbox class="text-left" v-model="filter.forPolice" @changed="policeChange">
                                Filter za dopis policiji/komunalnoj
                            </base-checkbox>
                            <base-checkbox class="text-left" v-model="filter.stranciOnly">
                                Prikazi samo strance
                            </base-checkbox>

                            <base-checkbox class="text-left" v-model="filter.rentOnly">
                                Prikazi samo Rent a car
                            </base-checkbox>

                            <base-checkbox class="text-left" v-model="filter.otherThanHn">
                                Prikazi sve MNE tablice sem HN
                            </base-checkbox>
                        </div>
                        <div class="col-md-3">
                            <!-- <card> -->
                            <h4 slot="header" class="card-title"> </h4>
                            <base-button class="mt-3" native-type="submit" type="primary"
                                @click="getTickets()">Pretraži</base-button>

                            <!-- <base-button class="mt-3" native-type="submit" type="primary" @click="getExcel()">Preuzmi
                                excel</base-button> -->
                            <base-button class="mt-3" native-type="submit" type="primary" @click="markAll()">Selektuj
                                sve
                                kazne</base-button>

                            <base-input label="Broj redova">
                                <el-select v-model="max" class="select-primary" name="zone" style="width: 200px;">
                                    <el-option v-for="zone in rows" class="select-primary" :label="zone.name"
                                        :value="zone.value" :key="zone.value"></el-option>
                                </el-select>
                            </base-input>
                            <!-- </card> -->
                        </div>
                    </div>
                    <!-- <base-checkbox v-if="warningTickets.length > 0" class="text-left" v-model="onePlateOwner">
                        JEDAN VLASNIK ZA OPOMENE
                    </base-checkbox> -->
                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="getWarningData()">Opomena</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="showMultipleTickets()">UPLATA</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="cancelMultipleTicketsPrompt()">PONISTI</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="savePlateRequest(true)">Dopis komunalnoj policiji</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="savePlateRequest(false)">Dopis policiji</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="getExcel(false)">Excel bez slika</base-button>
                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="getExcel(true)">Excel sa slikama</base-button>

                    <base-button v-if="warningTickets.length > 0" class="mt-3" native-type="submit" type="primary"
                        @click="getTicketsPdf()">Izveštaj za opomene</base-button>

                    <base-button v-if="warningTickets.length > 0 && filter.paymentStatusId === '4'" class="mt-3" native-type="submit" type="primary"
                        @click="getTicketsStornoPdf('IZVEŠTAJ O STORNIRANIM DOPLATNIM KARTAMA')">Izveštaj storniranih
                        dk</base-button>

                    <base-button v-if="warningTickets.length > 0 && filter.paymentStatusId === '1'" class="mt-3" native-type="submit" type="primary"
                        @click="getTicketsStornoPdf('IZVEŠTAJ O PLACENIM DOPLATNIM KARTAMA')">Izveštaj plaćenih
                        dk</base-button>

                    <h2 v-if="warningTickets.length > 0" style="color: white">
                        Selektovano: {{ totalWarningTickets }} EUR ({{ warningTickets.length }})
                    </h2>

                    <el-table :data="tickets" v-loading="ticketsLoading" @sort-change="handleSort"
                        :default-sort="{ prop: sortField, order: sortOrder }">

                        <el-table-column min-width="30" prop="checked" label="">
                            <template slot-scope="scope">
                                <span>
                                    <base-checkbox class="text-left" @input="ticketChecked(scope.row)"
                                        v-model="scope.row.checked">

                                    </base-checkbox>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="130" prop="stamp" label="Datum" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="80" prop="serviceNumber" label="Kontrolor">
                            <template slot-scope="scope">
                                <span>{{ scope.row.employee.name }} {{ scope.row.employee.lastName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="client" label="Zona">
                            <template slot-scope="scope">
                                <span v-if="scope.row.client">{{ scope.row.client.name }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="200" prop="parking" label="Lokacija">
                            <template slot-scope="scope">
                                <span v-if="scope.row.parking">{{ scope.row.parking.name }}</span>
                                <span v-else>{{ scope.row.parkingName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column min-width="100" prop="country_mark" label="Zemlja" sortable="custom">
                            <template slot-scope="scope">
                                <span>
                                    <base-input type="text" v-model="scope.row.countryMark"></base-input>
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="plates" label="Tablice" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.plates }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="60" prop="price" label="Cena" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.price }} EUR</span>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="paymentStatus" label="Status">
                            <template slot-scope="scope">
                                <span v-if="scope.row.paymentStatus.id === '2'" style="color: red">{{
                                    scope.row.paymentStatus.name }}</span>
                                <span v-else-if="scope.row.paymentStatus.id === '1'" style="color: green">{{
                                    scope.row.paymentStatus.name }}</span>
                                <span v-else>{{ scope.row.paymentStatus.name }}</span>


                            </template>
                        </el-table-column>

                        <el-table-column min-width="100" prop="ticket_number" label="ID" sortable="custom">
                            <template slot-scope="scope">
                                <span>{{ scope.row.ticketNumber }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="filter.rentOnly" min-width="60" prop="price" label="Rent-a-car">
                            <template slot-scope="scope">
                                <span>{{ scope.row.rentCarPlates?.rentCar?.name }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column v-if="filter.filterOldTickets" min-width="100" prop="oldTickets"
                            label="Stare kazne">
                            <template slot-scope="scope">
                                <span>{{ scope.row.oldTickets }}</span>
                                <base-button v-if="scope.row.oldTickets > 0" :type="'success'" class="btn-link"
                                    @click="getOldTickets(scope.row)">
                                    Prikazi
                                </base-button>
                            </template>
                        </el-table-column>

                        <el-table-column min-width="200" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">
                                <base-button :type="'primary'" class="btn-link"
                                    @click="ticket = scope.row; getPayments()">
                                    Uplate
                                </base-button>
                                <base-button :type="'success'" class="btn-link" @click="getTicket(scope.row)">
                                    Detalji
                                </base-button>

                            </div>
                        </el-table-column>
                    </el-table>
                    <div class="block">
                        <span class="demonstration" style="color: white;">Ukupno stranica: {{ totalPages }}</span><br>
                        <base-pagination class="pagination-no-border" v-model="page" :per-page="max"
                            :total="totalRecords" @input="changeP">
                        </base-pagination>
                    </div>
                </card>
            </div>


        </div>
        <modal :show.sync="showTicket" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicket = false; ticket = {}">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <div class="row">
                <div class="col-md-12">
                    <card>
                        ID: {{ ticket.ticketNumber }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.plates }}&nbsp;&nbsp;&nbsp;
                        <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }} -
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}&nbsp;&nbsp;&nbsp;
                        {{ ticket.exceded }}
                    </card>
                </div>
                <!-- <div class="col-md-4">
                    <card>
                        <template v-if="ticket.checkedPlates">
                            {{ (new Date(ticket.checkedPlates?.stamp)).toLocaleString("de-DE") }}<br>
                        </template>
                        {{ (new Date(ticket.stamp)).toLocaleString("de-DE") }}
                    </card>
                </div> -->
                <!-- <div class="col-md-4">
                    <card>
                        {{ ticket.parking?.client.name }}
                    </card>
                </div> -->

            </div>

            <div class="row">
                <div class="col-md-12">
                    <card v-if="ticket.parking">
                        {{ ticket.parking?.client.name }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.parking?.name }} - Parking mesto: {{ ticket.parkingSpace?.number
                        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.countryMark }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.price }}
                        EUR
                    </card>
                    <card v-else>
                        {{ ticket.client?.name }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.parkingName }}
                        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.countryMark }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        {{ ticket.price }}
                        EUR
                    </card>
                </div>
                <!-- <div class="col-md-4">
                    <card>
                        {{ ticket.plates }}
                    </card>
                </div>
                <div class="col-md-4">
                    <card>
                        {{ ticket.countryMark }}
                    </card>
                </div> -->


            </div>
            <div class="row">
                <!-- <div class="col-md-4">
                    <card>
                        {{ ticket.parkingInspectionItem?.inspectionItem?.name }}, {{
            ticket.parkingInspectionItem?.price }}
                        EUR
                    </card>
                </div> -->

                <div class="col-md-12">
                    <!-- {{ ticket.paymentStatus?.name }} -->
                    <card>
                        <base-input>

                            <el-select v-if="user.roleName === 'admin' || user.roleName === 'superadmin'"
                                v-model="ticket.paymentStatus" class="select-primary" name="zone" value-key="id"
                                style="width: 200px;">
                                <el-option v-for="zone in paymentStatuses" class="select-primary" :label="zone.name"
                                    :value="zone" :key="zone.id"></el-option>
                            </el-select>
                            <h3 v-else>{{ ticket.paymentStatus?.name }}</h3><br>
                            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                                @click="saveTicketPrompt()">Sačuvaj</base-button>
                            <!-- <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                                @click="saveKiosk()">Opomena</base-button> -->

                            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                                @click="getTIcketHistory()">Istorija</base-button>

                            <!-- <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                                @click="getPayments()">UPLATE</base-button> -->
                        </base-input>
                    </card>

                </div>

                <!-- <div class="col-md-4">
                            <card>
                            <base-button class="mt-3" native-type="submit" type="primary" @click="saveKiosk()">Sačuvaj</base-button>
                        </card>
                        </div> -->
            </div>
            <tabs type="primary">
                <tab-pane label="Doplatna karta">

                    <template>
                        <img v-for="img in ticket.images" class="card-img" style="width: 150px;" :key="img"
                            @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                </tab-pane>

                <tab-pane v-if="ticket.checkedPlates" label="Prvo skeniranje">
                    <template>
                        <img v-for="img in ticket.checkedPlates?.images" class="card-img" style="width: 150px;"
                            :key="img" @click="image = 'https://budva.scancar.org:8443' + img; showImage = true"
                            :src="'https://budva.scancar.org:8443' + img" alt="Image" />&nbsp;
                    </template>
                </tab-pane>



            </tabs>

        </modal>
        <modal :show.sync="showImage" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showImage = false; image = null">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <card class="stacked-form" title="Stacked Form">
                <h4 slot="header" class="card-title">{{ ticket.plates }}</h4>
                <img class="card-img" :src="image" alt="Image" />&nbsp;

            </card>


        </modal>

        <modal :show.sync="showOldTickets" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showOldTickets = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <el-table :data="oldTickets">

                <el-table-column min-width="140" prop="stamp" label="Datum" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ (new Date(scope.row.stampLong)).toLocaleString("de-DE") }}</span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="client" label="Zona">
                    <template slot-scope="scope">
                        <span v-if="scope.row.client">{{ scope.row.client.name }}</span>
                    </template>
                </el-table-column>


                <el-table-column min-width="100" prop="plates" label="Tablice" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.plates }}</span>
                    </template>
                </el-table-column>

                <el-table-column min-width="60" prop="price" label="Cena" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.price }}</span>
                    </template>
                </el-table-column>

                <el-table-column min-width="150" prop="paymentStatus" label="Status">
                    <template slot-scope="scope">
                        <span v-if="scope.row.paymentStatus.id === '2'" style="color: red">{{
                            scope.row.paymentStatus.name }}</span>
                        <span v-else-if="scope.row.paymentStatus.id === '1'" style="color: green">{{
                            scope.row.paymentStatus.name }}</span>
                        <span v-else>{{ scope.row.paymentStatus.name }}</span>


                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="ticket_number" label="ID" sortable="custom">
                    <template slot-scope="scope">
                        <span>{{ scope.row.ticketNumber }}</span>
                    </template>
                </el-table-column>



                <!-- <el-table-column min-width="100" header-align="right" align="right" label="Actions">
                            <div slot-scope="scope" class="text-right table-actions">

                                <base-button :type="'success'" class="btn-link"
                                    @click="getTicket(scope.row)">
                                    Detalji
                                </base-button>

                            </div>
                        </el-table-column> -->


            </el-table>
            <base-button :type="'danger'" size="sm" class="btn-link" @click="showOldTickets = false;">
                Zatvori
            </base-button>
        </modal>

        <modal :show.sync="showTicketHistory" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showTicketHistory = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <el-table :data="thicketHistory">
                <el-table-column min-width="150" prop="number" label="Dogadjaj">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.log }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="150" prop="active" label="Komentar">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.comment }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Korisnik">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.userName }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Datum">
                    <template slot-scope="scope">
                        <span>
                            {{ (new Date(scope.row.stamp)).toLocaleString("de-DE") }}
                        </span>
                    </template>
                </el-table-column>


            </el-table>
            <base-button :type="'danger'" size="sm" class="btn-link" @click="showTicketHistory = false;">
                Zatvori
            </base-button>
        </modal>

        <modal :show.sync="showPayments" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="showPayments = false;">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>


            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                @click="payment = {}; editPayment = true">Nova uplata</base-button>
            <el-table :data="payments">
                <el-table-column min-width="150" prop="number" label="Datum">
                    <template slot-scope="scope">
                        <span>
                            {{ (new Date(scope.row.payment.stampLong)).toLocaleString("de-DE") }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="150" prop="active" label="Ime">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.payment.name }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Iznos">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.payment.amount }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Izvod">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.payment.paymentInfo }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Način plaćanja">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.payment.paymentType?.name }}
                        </span>
                    </template>
                </el-table-column>

                <el-table-column min-width="100" prop="active" label="Kazne">
                    <template slot-scope="scope">
                        <span>

                            <template v-if="scope.row.otherTickets">
                                {{ scope.row.otherTickets.length }}
                                <base-button :type="'primary'" class="btn-link"
                                    @click="payment = scope.row.payment; editPayment = true;">
                                    Prikazi
                                </base-button>
                            </template>
                            <template v-else>0</template>

                        </span>
                    </template>
                </el-table-column>

                <!-- <el-table-column v-if="user.roleName === 'admin' || user.roleName === 'superadmin'" min-width="100" prop="active" label="''">
                    <template slot-scope="scope">
                        <span>
                            <base-button :type="'primary'" class="btn-link"
                                @click="payment = scope.row.payment; editPayment = true;">
                                Izmeni
                            </base-button>

                            <base-button :type="'danger'" class="btn-link"
                                @click="payment = scope.row; showDeletePaymentPrompt()">
                                Obriši
                            </base-button>
                        </span>
                    </template>
                </el-table-column> -->


            </el-table>
            <base-button :type="'danger'" size="sm" class="btn-link" @click="showPayments = false;">
                Zatvori
            </base-button>
        </modal>

        <modal :show.sync="editPayment" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link" @click="editPayment = false; payment = []">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>

            <div class="row">
                <div class="col-md-3">
                    <base-input label="Ime" type="text" v-model="payment.name" placeholder="Ime">
                    </base-input>
                </div>
                <div class="col-md-3">
                    <base-input label="Iznos" type="text" v-model="payment.amount" placeholder="Iznos">
                    </base-input>
                </div>

                <div class="col-md-3">
                    <base-input label="Izvod" type="text" v-model="payment.paymentInfo" placeholder="Izvod">
                    </base-input>
                </div>

                <div class="col-md-3">
                    <base-input label="Način plaćanja">
                        <el-select v-model="payment.paymentType" class="select-primary" name="zone" value-key="id"
                            style="width: 170px;">
                            <el-option v-for="zone in paymentTypes" class="select-primary" :label="zone.name"
                                :value="zone" :key="zone.id"></el-option>
                        </el-select>
                    </base-input>
                </div>



            </div>
            <br><br>
            <!-- <div v-if="multipleTickets" class="row">
                <h4>Doplatne karte</h4>
                <template v-for="t in warningTickets">
                    <div class="col-md-12">
                        <p style="color: white;">
                            {{ t.ticketNumber }} {{ t.plates }}
                            <base-input type="number" v-model="t.payedAmount" style="width: 150px;"></base-input>
                        </p><br>
                    </div>
                </template>
            </div> -->
            <div v-if="multipleTickets" class="row">
                <h4>Doplatne karte</h4>

                <!-- Odaberi za sve -->
                <div class="col-md-12" style="margin-bottom: 15px;">
                    <label style="color: white; margin-right: 15px;"><b>Postavi za sve:</b></label>
                    <label style="color: white; margin-right: 20px;">
                        <input type="radio" value="full" v-model="applyAllPrice" @change="applyPriceToAll('full')"
                            style="margin-right: 5px;">
                        Puna cijena
                    </label>
                    <label style="color: white;">
                        <input type="radio" value="discount" v-model="applyAllPrice"
                            @change="applyPriceToAll('discount')" style="margin-right: 5px;">
                        Cijena sa popustom
                    </label>
                </div>

                <template v-for="t in warningTickets">
                    <div class="col-md-12">
                        <div
                            style="border: 1px solid rgba(255,255,255,0.2); border-radius: 8px; padding: 12px; margin-bottom: 10px; background: rgba(255,255,255,0.05);">

                            <!-- Gornji red: broj karte + tablice + iznos -->
                            <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 10px;">
                                <span style="color: white; font-weight: bold;">{{ t.ticketNumber }}</span>
                                <span style="color: #aaa;">{{ t.plates }}</span>
                                <base-input type="number" v-model="t.payedAmount"
                                    style="width: 150px; margin: 0;"></base-input>
                            </div>

                            <!-- Donji red: radio buttons za cijenu -->
                            <div style="display: flex; gap: 20px;">
                                <label style="color: white; margin: 0;">
                                    <input type="radio" :value="t.client.ticketPrice" v-model="t.price"
                                        style="margin-right: 5px;">
                                    Puna: <b>{{ t.client.ticketPrice }}</b>
                                </label>
                                <label style="color: white; margin: 0;"
                                    v-if="ticket.client?.ticketPriceWithDiscount > 0">
                                    <input type="radio" :value="t.client?.ticketPriceWithDiscount" v-model="t.price"
                                        style="margin-right: 5px;">
                                    Sa popustom: <b>{{ t.client?.ticketPriceWithDiscount }}</b>
                                </label>
                            </div>

                        </div>
                    </div>
                </template>
            </div>
            <div v-else-if="ticket && ticket.client">
                <div class="row">
                    <div class="col-md-12">
                        <label style="color: white; margin-right: 20px;">
                            <input type="radio" :value="ticket.client.ticketPrice" v-model="ticket.price"
                                style="margin-right: 5px;">
                            Cijena: {{ ticket.client.ticketPrice }}
                        </label>
                        <label style="color: white;" v-if="ticket.client.ticketPriceWithDiscount > 0">
                            <input type="radio" :value="ticket.client.ticketPriceWithDiscount" v-model="ticket.price"
                                style="margin-right: 5px;">
                            Cijena sa popustom: {{ ticket.client.ticketPriceWithDiscount }}
                        </label>
                    </div>
                </div>
            </div>




            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                @click="savePayment()">Sačuvaj uplatu</base-button>
            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                @click="editPayment = false; payment = {}">Odustani</base-button>
        </modal>

        <modal :show.sync="showWarningData" :show-close="true" :scrollToBottom="true" :appendToBody="true"
            modalClasses="custom-modal" modalContentClasses="custom-modal-content" bodyClasses="custom-modal-body">
            <base-button :type="'danger'" icon size="sm" class="btn-link"
                @click="showWarningData = false; warningData = []">
                <i class="tim-icons icon-simple-remove"></i>
            </base-button>
            <template v-if="onePlateOwner">
                <base-input label="TIP opomene">
                    <el-select v-model="warningType" class="select-primary" name="zone" style="width: 200px;">
                        <el-option v-for="zone in warningTypes" class="select-primary" :label="zone.name"
                            :value="zone.value" :key="zone.value"></el-option>
                    </el-select>
                </base-input>
                <base-input label="Delovodni broj" type="text" style="width: 150px" v-model="delovodniBroj">

                </base-input>
                <div class="row">
                    <div class="col-md-4">
                        <base-input label="Ime" type="text" v-model="plateOwner.name" placeholder="Ime">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Prezime" type="text" v-model="plateOwner.lastName" placeholder="Prezime">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Ime oca" type="text" v-model="plateOwner.fatherName" placeholder="Ime oca">
                        </base-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <base-input label="Grad" type="text" v-model="plateOwner.city" placeholder="Grad">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Adresa" type="text" v-model="plateOwner.address" placeholder="Adresa">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Država" type="text" v-model="plateOwner.country" placeholder="Država">
                        </base-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <base-input label="Maticni broj" type="text" v-model="plateOwner.personalNumber"
                            placeholder="Maticni broj">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Pib" type="text" v-model="plateOwner.pib" placeholder="Pib">
                        </base-input>
                    </div>
                    <div class="col-md-4">

                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <base-input label="Tablice" type="text" v-model="plateOwner.plates" placeholder="Tablice">
                        </base-input>
                    </div>
                    <div class="col-md-4">
                        <base-input label="Datum dobijanja podataka">
                            <el-date-picker type="date" placeholder="Datum dobijanja podataka" value-format="timestamp"
                                format="dd.MM.yyyy. HH:mm:ss" v-model="plateOwner.stampLong">
                            </el-date-picker>
                        </base-input>
                    </div>
                    <div class="col-md-4">

                    </div>
                </div>
            </template>
            <!-- <template v-else>
                <el-table :data="warningData">
                    <el-table-column min-width="80" prop="plates" label="Tablice">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.plates }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="50" prop="price" label="Iznos">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.row.price }} EUR
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column min-width="300" prop="active" label="Vlasnik">
                        <template slot-scope="scope">
                            <span>
                                <div class="row">
                                    <div class="col-md-4">
                                        <base-input label="Ime" type="text" v-model="scope.row.plateOwner.name"
                                            placeholder="Ime">
                                        </base-input>
                                    </div>
                                    <div class="col-md-4">
                                        <base-input label="Prezime" type="text" v-model="scope.row.plateOwner.lastName"
                                            placeholder="Prezime">
                                        </base-input>
                                    </div>

                                    <div class="col-md-4">
                                        <base-input label="Država" type="text" v-model="scope.row.plateOwner.country"
                                            placeholder="Država">
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Grad" type="text" v-model="scope.row.plateOwner.city"
                                            placeholder="Grad">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input label="Adresa" type="text" v-model="scope.row.plateOwner.address"
                                            placeholder="Adresa">
                                        </base-input>
                                    </div>


                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <base-input label="Poštanski broj" type="text"
                                            v-model="scope.row.plateOwner.postNumber" placeholder="Poštanski broj">
                                        </base-input>
                                    </div>
                                    <div class="col-md-6">
                                        <base-input label="Datum dobijanja podataka">
                                            <el-date-picker type="date" placeholder="Datum dobijanja podataka" format="dd.MM.yyyy."
                                                value-format="timestamp" v-model="scope.row.plateOwner.stampLong">
                                            </el-date-picker>
                                        </base-input>
                                    </div>
                                </div>



                            </span>
                        </template>
                    </el-table-column>

                </el-table>
            </template> -->
            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="primary"
                @click="generateWarnings()">Generiši</base-button>
            <base-button class="mt-3" native-type="submit" style="margin-left: 20px;" type="danger"
                @click="showWarningData = false; warningData = {}">Odustani</base-button>
        </modal>
    </div>
</template>
<script>
import { TabPane, Tabs, Collapse, CollapseItem, BasePagination } from 'src/components';
import { Table, TableColumn, TimeSelect, DatePicker, Select, Option } from 'element-ui';
import { BaseCheckbox, BaseProgress, RouteBreadCrumb } from 'src/components';
import axios from '@/util/axiosinstance'
import swal from 'sweetalert2';
import { BaseNav, Modal } from '@/components';
import htmlDocx from 'html-docx-js';
import { saveAs } from 'file-saver';

const rows = [
    { value: 10, name: "10" },
    { value: 20, name: "20" },
    { value: 50, name: "50" },
    { value: 100, name: "100" },
    { value: 500, name: "500" },
    { value: 1000, name: "1000" }
]

const warningTypes = [
    { value: 0, name: "Prva opomena" },
    { value: 1, name: "Druga opomena" }
]

export default {
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [DatePicker.name]: DatePicker,
        [TimeSelect.name]: TimeSelect,
        [Option.name]: Option,
        [Select.name]: Select,
        TabPane,
        Tabs,
        Collapse,
        CollapseItem,
        Modal,
        BasePagination
    },
    mounted() {
        // this.getTickets()
        this.getZones()
        this.getEmployees()
        this.getPaymentStatuses()
        this.getPaymentTypes()
        this.user = JSON.parse(localStorage.getItem("user"));
        this.getUserPageFilter()
        // console.log("User", this.user);
    },
    data() {
        const now = new Date();

        // Postavljanje startStamp na 00:00:00 danas
        const startStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime();

        // Postavljanje endStamp na 23:59:59 danas
        const endStamp = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();

        return {
            applyAllPrice: 'full',
            rows,
            url: 'https://budva.scancar.org:8443/kuca',
            fileUrl: 'https://budva.scancar.org:8443',
            ticketsLoading: false,
            loading: false,
            tickets: [],
            filter: {
                startStamp: startStamp,
                endStamp: endStamp,
                ticketNumber: null,
                plates: null,
                countryMark: null,
                employeeId: null,
                paymentStatusId: null,
                clientId: null,
                filterOldTickets: false,
                stranciOnly: false,
                rentOnly: false,
                otherThanHn: false,
                forPolice: false,
                startActionStamp: null,
                endActionStamp: null
            },
            employees: [],
            paymentStatuses: [],
            zones: [],
            ticketsLoading: false,
            ticket: {},
            showTicket: false,
            image: null,
            showImage: false,
            thicketHistory: [],
            showTicketHistory: false,
            warningTickets: [],
            warningData: [],
            showWarningData: false,
            page: 1,
            max: 100,
            totalRecords: 0,
            totalPages: 0,
            sortField: "stamp",
            sortOrder: "descending",
            totalPrice: 0,
            showOldTickets: false,
            oldTickets: [],
            payments: [],
            showPayments: false,
            payment: {},
            editPayment: false,
            paymentTypes: [],
            user: {},
            multipleTickets: false,
            onePlateOwner: true,
            plateOwner: {},
            warningTypes,
            warningType: 0,
            comment: "",
            totalWarningTickets: 0,
            delovodniBroj: ""
        };
    },
    methods: {
        applyPriceToAll(type) {
            this.warningTickets.forEach(t => {
                t.price = type === 'full' ? t.client.ticketPrice : t.client.ticketPriceWithDiscount;
            });
        },
        policeChange() {

            if (this.filter.forPolice) {
                const swalWithBootstrapButtons4 = swal.mixin({
                    customClass: {
                        confirmButton: "btn btn-success btn-fill",
                        cancelButton: "btn btn-danger btn-fill",
                    },
                    buttonsStyling: false,
                });

                swalWithBootstrapButtons4
                    .fire({
                        title: "Ovo je filter koji ce izlistati tablice za koje ne postoje podaci o vlasnistvu. Izlistace i stare neplacene doplatne karte i vazi samo za MNE tablice. NEMOJTE UZIMATI PERIOD VECI OD MESEC DANA.",
                        confirmButtonText: "U redu",
                        cancelButtonText: "Odustani",
                        showCancelButton: false
                    })
                    .then((result) => {
                        if (result.isConfirmed) {

                        }
                    });
                this.filter.filterOldTickets = true
                this.filter.paymentStatusId = "2"
            }
        },
        markAll() {
            this.warningTickets = []
            this.totalWarningTickets = 0
            for (let i = 0; i < this.tickets.length; i++) {
                console.log(this.tickets[i].plates);
                this.$set(this.tickets[i], 'checked', true);
                this.ticketChecked(this.tickets[i]);
            }
        },
        showMultipleTickets() {
            this.payment = {};
            let amm = 0;
            for (let i = 0; i < this.warningTickets.length; i++) {
                let t = this.warningTickets[i]
                amm += t.price
                t.payedAmount = t.price
            }
            this.payment.amount = amm
            this.multipleTickets = true;
            this.editPayment = true
        },
        changeP(item) {
            this.page = item
            this.getTickets()
        },
        handleSort({ prop, order }) {
            this.sortField = prop;
            this.sortOrder = order;

            this.getTickets()
        },
        getUserPageFilter() {
            this.loading = true

            axios.get(this.url + '/settings/getUserPageFilter?page=3').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.filter = result.data.filter
                } else {
                    // this.$notify({
                    //     message:
                    //         result.data.reason,
                    //     timeout: 3000,
                    //     icon: 'tim-icons icon-bell-55',
                    //     horizontalAlign: "right",
                    //     verticalAlign: "top",
                    //     type: 'danger'
                    // });
                }
                this.getTickets()
            })
        },
        getPaymentTypes() {
            this.loading = true

            axios.get(this.url + '/payment/getPaymentTypes').then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.paymentTypes = result.data.paymentTypes
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        savePayment() {
            this.loading = true

            const tickets = []
            if (!this.multipleTickets) {
                this.ticket.payedAmount = this.payment.amount
                tickets.push(this.ticket)
                this.payment.tickets = tickets
            } else {
                this.payment.tickets = this.warningTickets
            }

            axios.post(this.url + '/payment/savePayment', this.payment).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            "Sacuvano",
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.editPayment = false
                    this.payment = {}
                    if (!this.multipleTickets) {
                        this.getPayments()
                    }
                    this.getTickets()
                    if (!this.multipleTickets) {
                        this.getTicket()
                    }

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getPayments() {
            this.loading = true

            axios.post(this.url + '/payment/getTicketPayments', this.ticket).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.payments = result.data.payments
                    this.showPayments = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getOldTickets(t) {
            this.loading = true

            axios.post(this.url + '/ticket/getOldTickets', t).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.oldTickets = result.data.tickets
                    this.showOldTickets = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getTicket(t) {
            this.loading = true

            axios.get(this.url + '/ticket/getTicket?id=' + t.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.ticket = result.data.ticket
                    this.showTicket = true
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getWarningData() {
            this.plateOwner = {
                country: "CRNA GORA",
                city: "Budva"
            }
            this.loading = true
            const body = {}
            body.warningTickets = this.warningTickets
            body.onePlateOwner = this.onePlateOwner
            axios.post(this.url + '/ticket/getWarningData', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.warningData = result.data.warningData
                    this.showWarningData = true
                    this.plateOwner = result.data.plateOwner
                    if (!this.plateOwner.id) {
                        this.plateOwner = {
                            country: "CRNA GORA",
                            city: "Budva"
                        }
                    }
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        generateWarnings() {
            this.loading = true
            const body = {}
            body.warningData = this.warningData
            body.warningType = this.warningType
            this.totalWarningTickets = 0
            body.onePlateOwner = this.onePlateOwner
            body.plateOwner = this.plateOwner
            body.delovodniBroj = this.delovodniBroj
            axios.post(this.url + '/ticket/saveWarnings', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            "Generisano",
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.showWarningData = false
                    this.warningData = []
                    this.warningTickets = []

                    if (result.data.fileName) {

                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/" + result.data.fileName;

                        link.download = "";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }

                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        savePlateRequest(komunalna) {
            this.loading = true
            const body = {}
            body.warningTickets = this.warningTickets
            body.komunalna = komunalna
            // body.warningType = this.warningType
            // body.onePlateOwner = this.onePlateOwner
            // body.plateOwner = this.plateOwner
            axios.post(this.url + '/ticket/savePlateRequest', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            "Generisano",
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.showWarningData = false
                    this.warningData = []

                    if (result.data.fileName) {
                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/" + result.data.fileName;
                        // Ako želiš da specificiraš ime fajla, postavi atribut download, npr:
                        // link.download = "fajl.pdf";
                        // Ako ostaviš prazno, browser će pokušati da koristi ime koje je na serveru
                        link.download = "";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        ticketChecked(ticket) {
            if (ticket.checked) {
                this.warningTickets.push(ticket)
                this.totalWarningTickets += ticket.price
            } else {
                const index = this.warningTickets.indexOf(ticket);
                if (index !== -1) {
                    this.warningTickets.splice(index, 1); // Uklanja objekat na datom indeksu
                    this.totalWarningTickets -= ticket.price
                }
            }
        },
        saveTicket() {
            this.loading = true
            axios.post(this.url + '/ticket/cancelTicket', this.ticket).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Sačuvano',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });

                    this.getTickets()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        cancelMultipleTickets() {
            this.loading = true
            const body = {
                comment: this.comment,
                tickets: this.warningTickets
            }
            axios.post(this.url + '/ticket/cancelMultipleTickets', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.$notify({
                        message:
                            'Ponisteno',
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'success'
                    });
                    this.warningTickets = []
                    this.totalWarningTickets = 0
                    this.getTickets()
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getTIcketHistory() {
            this.loading = true
            axios.get(this.url + '/ticket/getTicketHistory?ticketId=' + this.ticket.id).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    this.thicketHistory = result.data.history
                    this.showTicketHistory = true
                } else {

                }
            })
        },
        getZones() {
            // this.zonesLoading = true
            axios.get(this.url + '/client/getClients').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.zones = result.data.clients
                } else {

                }
            })
        },
        getPaymentStatuses() {
            // this.zonesLoading = true
            axios.get(this.url + '/settings/getPaymentStatuses').then(result => {
                // this.zonesLoading = false

                if (result.data.result === 'ok') {
                    this.paymentStatuses = result.data.paymentStatuses
                } else {

                }
            })
        },
        getEmployees() {
            // this.employeesLoading = true
            axios.get(this.url + '/employee/getEmployees').then(result => {
                // this.employeesLoading = false

                if (result.data.result === 'ok') {
                    this.employees = result.data.employees
                } else {

                }
            })
        },
        getTickets() {
            this.ticketsLoading = true
            // if(this.filter.filterOldTickets){
            this.loading = true
            // }
            this.totalWarningTickets = 0
            this.warningData = []
            this.warningTickets = []
            const f = this.filter
            f.page = this.page
            f.max = this.max
            if (this.filter.forPolice) {
                this.max = 1000
                f.max = this.max
            }
            f.sortField = this.sortField
            f.sortOrder = this.sortOrder
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/ticket/getTickets', f).then(result => {
                this.ticketsLoading = false
                this.loading = false

                if (result.data.result === 'ok') {
                    this.tickets = result.data.tickets
                    this.totalPages = result.data.totalPages
                    this.totalRecords = result.data.totalRecords
                    this.totalPrice = result.data.totalPrice
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getExcel(withImages) {
            this.loading = true
            // const f = this.filter
            const body = {
                tickets: this.warningTickets,
                withImages: withImages
            }
            // f.page = this.page
            // f.max = this.max
            // f.sortField = this.sortField
            // f.sortOrder = this.sortOrder
            // f.startStamp = this.filter.startStamp.getTime()
            // f.endStamp = this.filter.endStamp.getTime()
            axios.post(this.url + '/ticket/getExcel', body).then(result => {
                this.loading = false

                if (result.data.result === 'ok') {
                    (async () => {
                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/DoplatneKarte.xlsx";

                        link.download = "";
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        await new Promise(resolve => setTimeout(resolve, 1000));

                        if (result.data.zipUrl) {
                            const link = document.createElement('a');
                            link.href = this.fileUrl + "/opomene/" + result.data.zipUrl;

                            link.download = "";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                        }

                    })();
                    // // if (result.data.fileName) {
                    // const link = document.createElement('a');
                    // link.href = this.fileUrl + "/opomene/DoplatneKarte.xlsx";
                    // // Ako želiš da specificiraš ime fajla, postavi atribut download, npr:
                    // // link.download = "fajl.pdf";
                    // // Ako ostaviš prazno, browser će pokušati da koristi ime koje je na serveru
                    // link.download = "";
                    // document.body.appendChild(link);
                    // link.click();
                    // document.body.removeChild(link);
                    // // }
                } else {
                    this.$notify({
                        message:
                            result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            })
        },
        getTicketsPdf() {
            this.loading = true;
            const body = {
                tickets: this.warningTickets
            };

            axios.post(this.url + '/ticket/getTicketsPdf', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    (async () => {
                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/DoplatneKarteIzvestaj.pdf";
                        link.download = "DoplatneKarteIzvestaj.pdf"; // Dodaj konkretno ime fajla
                        link.target = "_blank"; // Otvori u novom tab-u
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        await new Promise(resolve => setTimeout(resolve, 1000));
                    })();
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        getTicketsStornoPdf(name) {
            this.loading = true;
            const body = {
                tickets: this.warningTickets,
                name: name
            };

            axios.post(this.url + '/ticket/getTicketsStornoPdf', body).then(result => {
                this.loading = false;
                if (result.data.result === 'ok') {
                    (async () => {
                        const link = document.createElement('a');
                        link.href = this.fileUrl + "/opomene/" + result.data.fileName;
                        link.download = result.data.fileName; // Dodaj konkretno ime fajla
                        link.target = "_blank"; // Otvori u novom tab-u
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        await new Promise(resolve => setTimeout(resolve, 1000));
                    })();
                } else {
                    this.$notify({
                        message: result.data.reason,
                        timeout: 3000,
                        icon: 'tim-icons icon-bell-55',
                        horizontalAlign: "right",
                        verticalAlign: "top",
                        type: 'danger'
                    });
                }
            });
        },
        navigateToPage() {
            this.$router.push({ name: 'Administration' });
        },
        deletePrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });
            swalWithBootstrapButtons4
                .fire({
                    title: "Da li ste sigurni da želite da parking mesto \"" + this.parkingSpace.number + "\"?",
                    text: ``,
                    confirmButtonText: "Da, obriši!",
                    cancelButtonText: "NE",
                    showCancelButton: true,
                })
                .then((result) => {
                    if (result.value) {
                        this.deleteParkingSpace()
                        // const swalWithBootstrapButtons5 = swal.mixin({
                        //     customClass: {
                        //     confirmButton: "btn btn-success btn-fill",
                        //     },
                        //     buttonsStyling: false,
                        // });
                        // swalWithBootstrapButtons5.fire({
                        //     title: "Deleted!",
                        //     text: "Your file has been deleted.",
                        // });
                    }
                });
        },
        cancelMultipleTicketsPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Molimo vas unesite komentar .",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.comment = comment;
                        this.cancelMultipleTickets()
                    }
                });
        },
        saveTicketPrompt() {
            const swalWithBootstrapButtons4 = swal.mixin({
                customClass: {
                    confirmButton: "btn btn-success btn-fill",
                    cancelButton: "btn btn-danger btn-fill",
                },
                buttonsStyling: false,
            });

            swalWithBootstrapButtons4
                .fire({
                    title: "Molimo vas unesite komentar za ovu promenu.",
                    html: `<textarea id="comment" class="swal2-textarea" placeholder="Komentar" style="width: 100%; height: 100px;"></textarea>`,
                    confirmButtonText: "Sačuvaj",
                    cancelButtonText: "Odustani",
                    showCancelButton: true,
                    preConfirm: () => {
                        const comment = document.getElementById("comment").value;
                        // if (!comment.trim()) {
                        //     Swal.showValidationMessage("Molimo unesite komentar pre nego što nastavite!");
                        // }
                        return comment;
                    },
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        const comment = result.value; // Dohvaćen komentar
                        console.log("Komentar:", comment); // Možete proslediti komentar funkciji
                        // this.deleteParkingSpace(comment);
                        this.ticket.comment = comment;
                        this.saveTicket()
                    }
                });
        }

    }
};
</script>
<style lang="scss">
/* Pozadina modala */
.custom-modal {
    background-color: rgba(0, 0, 0, 0.8);
}

.custom-modal-content {
    background-color: #3b3b5c;
    /* Tamna pozadina */
    color: #ffffff;
    /* Svetli tekst */
    border-radius: 8px;
    max-width: 800px;
    width: 800px;
}

/* Stil za telo modala */
.custom-modal-body {
    padding: 20px;
}

/* Stil za tabelu unutar modala */
.custom-table {
    width: 100%;
    border-collapse: collapse;
    background-color: #2c2c3e;
    /* Tamna pozadina tabele */
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table th {
    background-color: #3c3c4f;
    /* Tamna pozadina za zaglavlje */
    color: #ffffff;
    /* Beli tekst */
    padding: 10px;
    text-align: left;
    border: 1px solid rgba(255, 255, 255, 0.2);
}

.custom-table td {
    padding: 10px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.87);
    /* Svetlo sivi tekst */
}

.custom-table tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Istaknuta boja za hover */
}


.loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    /* Visina loadera */
    background-color: rgba(255, 255, 255, 0.7);
    /* Providna pozadina */
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 9999;
    /* Iznad ostalog sadržaja */
}

.loader {
    border: 8px solid #f3f3f3;
    /* Svetla boja */
    border-top: 8px solid #3498db;
    /* Boja animacije */
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>